import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View, Dimensions } from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect from "react-native-picker-select";
import { apiservice } from "../../service/service";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import { useIsFocused } from "@react-navigation/native";
import Tebleuserrank from "./tebleuserrank";
const { width, height } = Dimensions.get("window");

export default function userrank({ navigation, route }) {
  const item = route.params.item;
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setdata] = useState([]);
  const [lan, setlan] = useState("");
  const [state, setState] = useState(item?.distance?.[0]?.price);
  const [vip, setVip] = useState("GENERAL");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [items, setItems] = useState(() => {
    const distances = item?.distance || [];

    const normalItems = distances.map((e) => ({
      ...e,
      label:
        (lan == "en" ? "Distance " : "ระยะทาง ") +
        e.title +
        " (" +
        e?.price +
        (lan == "en" ? " baht)" : " บาท)"),
      value: e?.price,
    }));

    const premiumItems = distances
      .filter((e) => e?.premiumPrice !== undefined && e?.premiumPrice !== null)
      .map((e) => ({
        ...e,
        label:
          (lan == "en" ? "Distance " : "ระยะทาง ") +
          e.title +
          " (" +
          e?.premiumPrice +
          (lan == "en" ? " baht)" : " บาท)"),
        value: e?.premiumPrice,
      }));

    return [...normalItems, ...premiumItems];
  });

  async function getevent(page = 1) {
    const response = await apiservice({
      path: "/event/getrankingByEvent_id/" + item.id + "?page=" + page,
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setdata(response.data.data);
      setTotalPages(response.data.pagination?.totalPages ?? 1);
    }
  }

  function checkVip(vip) {
    if (vip == "VIP") {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    getevent(currentPage);
    const timer = setInterval(() => {
      getevent(currentPage);
    }, 1000);

    return () => clearInterval(timer);
  }, [focus, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [state, vip]);

  const filteredData = data?.filter((e) => {
    const distanceMatched =
      state == e?.pay_status || parseInt(state) + 99 == parseInt(e?.pay_status);

    if (!distanceMatched) {
      return false;
    }

    if (vip === "VIP") {
      return !!e?.isPremium;
    }

    return !e?.isPremium;
  });

  function handlePrevPage() {
    setCurrentPage((prev) => Math.max(1, prev - 1));
  }

  function handleNextPage() {
    setCurrentPage((prev) => Math.min(totalPages, prev + 1));
  }

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />

        <View style={styles.viewfree}>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.textfree}>Rank</Text>
            <Text style={styles.textfree1}>
              / <Text style={styles.textfree1}>{item.titel}</Text>
            </Text>
          </View>
          <View style={{ marginTop: 10, marginRight: 30 }}>
            <RNPickerSelect
              value={state}
              textInputProps={{ style: { fontFamily: "Prompt-Regular" } }}
              onValueChange={(select) => {
                setState(select);
              }}
              style={{
                inputAndroid: {
                  width: width * 0.8,
                  height: 33,
                  borderBottomWidth: 1,
                  borderBottomColor: "#00000060",
                  color: "#000000",
                  fontFamily: "Prompt-Regular",
                  alignSelf: "center",
                  paddingTop: 10,
                  zIndex: 999,
                  marginBottom: 10,
                },
              }}
              items={items}
            />
            <RNPickerSelect
              value={vip}
              textInputProps={{ style: { fontFamily: "Prompt-Regular" } }}
              onValueChange={(select) => {
                setVip(select);
              }}
              style={{
                inputAndroid: {
                  width: width * 0.8,
                  height: 33,
                  borderBottomWidth: 1,
                  borderBottomColor: "#00000060",
                  color: "#000000",
                  fontFamily: "Prompt-Regular",
                  alignSelf: "center",
                  paddingTop: 10,
                  zIndex: 999,
                  marginBottom: 10,
                },
              }}
              items={[
                { label: "VIP", value: "VIP" },
                { label: "GENERAL", value: "GENERAL" },
              ]}
            />
          </View>
        </View>
        <Tebleuserrank
          navigation={navigation}
          data={data}
          currentPage={currentPage}
          totalPages={totalPages}
          onPrevPage={handlePrevPage}
          onNextPage={handleNextPage}
        />
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    width: width * 0.83,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfil: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#000",
  },
  textfilits: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
  viewfil: {
    width: width * 0.83,
    backgroundColor: "#fff",
    height: 100,
    borderRadius: 10,
    marginTop: 10,
    padding: 10,
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
});
